import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';

import axiosInstance from '../../../config/axiosConfig';

import { Stepper, Step, StepLabel } from '@mui/material';
import { Toast } from 'primereact/toast';

import useSelectedCompanyStore from '../../../store/useSelectedCompanyStore';
import useCampaignStore from '../../../store/useCampaignStore';

import StepOne from './Step1';
import StepTwo from './step2';
import StepThree from './step3';
import StepFour from './step4';

const CampaignsCreate = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isValid, setIsValid] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [campaignCreated, setCampaignCreated] = useState(false);

    const [bigObject, setBigObject] = useState({});

    const [basicInfosObject, setBasicInfosObject] = useState(bigObject?.basicInfosObject || {});
    const [quizObject, setQuizObject] = useState(bigObject?.quizObject || []);
    const [selectedTests, setSelectedTests] = useState(bigObject?.selectedTests || {});

    const selectedCompany = useSelectedCompanyStore((state) => state.selectedCompany);
    const addCampaign = useCampaignStore((state) => state.addCampaign);

    const toast = useRef(null);

    const items = [
        { label: 'Informations générales' },
        { label: 'Questions de pré-qualification' },
        { label: 'Sélection des tests (LiAna)' },
        { label: 'Récapitulatif' }
    ];

    // Todo, replace the three functions below with a single handle function, and specify the step in the sent object.
    const handleBasicInfosChange = (object) => {
        setBasicInfosObject(object);
    };

    const handleQuizObjectChange = (object) => {
        setQuizObject(object);
    };

    const handleSelectedTestsObjectChange = (object) => {
        setSelectedTests(object);
    };

    useEffect(() => {
        setBigObject({ basicInfosObject, quizObject, selectedTests })
    }, [basicInfosObject, quizObject, selectedTests])

    const handleIsValid = (isValid) => {
        if (!isValid) return setIsValid(false);
        // Example of what to send back in case other steps are added in the future:
        // isValid = false || isValid = { step: '5' }
        if (isValid?.step === String(activeIndex)) return setIsValid(true);
    };

    const stepsComponents = [
        <StepOne handleChange={handleBasicInfosChange} inputText={basicInfosObject} isValid={handleIsValid} />,
        <StepTwo handleChange={handleQuizObjectChange} quizObject={quizObject} isValid={handleIsValid} />,
        <StepThree handleChange={handleSelectedTestsObjectChange} data={selectedTests} isValid={handleIsValid} />,
        <StepFour data={bigObject} />,
    ];

    const handleSubmit = () => {
        const transformedObject = {
            campaign_name: bigObject.basicInfosObject.campaign_name,
            language: bigObject.basicInfosObject.language,
            recruiter: bigObject.basicInfosObject.recruiter,
            quiz: bigObject.quizObject.map(page => ({
                title: page.title,
                questions: page.questions.map(question => {
                    const transformedQuestion = {
                        question: question.question,
                        type: question.type,
                    };
                    if (question.type !== "long" && question.type !== "short") {
                        transformedQuestion.choices = question.choices.filter(choice => choice !== "");
                    }
                    return transformedQuestion;
                })
            })),
            selectedTests: bigObject.selectedTests.selectedTests.map(test => ({
                ref: test.ref
            }))
        };

        setSubmitLoading(true);

        axiosInstance.post(`/dashboard/campaign/${selectedCompany?.company_id}/create`, transformedObject).then(response => {

            toast.current.show({ severity: 'success', summary: 'Succès', detail: 'Campagne créé avec succès !', life: 10000 });

            setCampaignCreated(true);

            let campaign = response?.data?.campaign;

            if (campaign) {
                addCampaign(campaign);

                setTimeout(() => {
                    window.location.href = `/dashboard/campaigns/${campaign?.campaign_id}/candidates`;
                }, 2000);

            } else {
                setTimeout(() => {
                    window.location.href = "/dashboard/campaigns";
                }, 1000);
            }

            setSubmitLoading(false);
        }).catch(error => {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la création de la campagne, veuillez vérifier le formulaire ou réessayer plus tard', life: 10000 });
            setSubmitLoading(false);
        });
    };

    return (
        <section className='home'>

            <Toast ref={toast} position="bottom-right" />

            <div className="container">
                <div className="columns is-vcentered is-multiline">
                    <div className="column is-full has-text-centered">
                        <p className="title is-2"><strong>Créer une nouvelle campagne</strong></p>
                        <Stepper activeStep={activeIndex} alternativeLabel>
                            {items.map((item, index) => (
                                <Step key={index}>
                                    <StepLabel>{item.label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </div>

                    <div className="column mt-6">
                        {stepsComponents[activeIndex]}
                    </div>

                </div>

                <div className="buttons is-justify-content-space-between">
                    <button className="button is-info is-outlined is-light is-large is-responsive mt-6 mb-6" disabled={activeIndex === 0} onClick={() => { setActiveIndex(activeIndex - 1), setIsValid(true) }}>Retour</button>
                    {activeIndex !== 3 && <button className="button is-info is-light is-large is-responsive mt-6 mb-6" disabled={!isValid} onClick={() => { setActiveIndex(activeIndex + 1) }}>Continuer</button>}
                    {activeIndex === 3 && <button className={clsx('button is-primary is-light is-outlined is-large is-responsive mt-6 mb-6', { 'is-loading': submitLoading })} onClick={() => { handleSubmit() }}
                        disabled={campaignCreated}
                    >Sauvegarder
                    </button>
                    }
                </div>

            </div>
        </section>
    );
};

export default CampaignsCreate;